<div class="container" (click)="select()">
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
    <div fxFlex>

      <h3 style="overflow-wrap: anywhere;">{{data.problemDetail.title}}</h3>

      <div *ngFor="let prop of data.problemDetail.errors | keyvalue" class="smaller-font">
        <div fxLayout="row" fxLayoutAlign="start start" style="text-align: end !important;">
          <div fxFlex="20">
            <b>{{prop.key}}</b>:
          </div>
          <div fxFlex="auto">
            <span *ngFor="let item of prop.value">
              {{item}}
            </span>
          </div>
        </div>
        <div class="small-spacer"></div>
      </div>

      <div *ngFor="let prop of data.problemDetail.extensions | keyvalue" class="smaller-font">
        <div fxLayout="row" fxLayoutAlign="start start">
          <div fxFlex="20">
            <b>{{prop.key}}</b>:
          </div>
          <div fxFlex="auto">
            {{prop.value | json}}
          </div>
        </div>
        <div class="small-spacer"></div>
      </div>

      <div *ngFor="let failure of data.problemDetail.failures" class="smaller-font">
        <p>
          <span>
            {{failure}}
          </span>
        </p>
      </div>
      <div class="spacer"></div>

    </div>

    <div *ngIf="!isMobileMode" fxFlex="nogrow">
      <mat-divider [vertical]="true" [inset]="false" style="height: 100px"></mat-divider>
    </div>

    <div *ngIf="!isMobileMode" fxFlex="nogrow">
      <div>
        <button (click)="close()" mat-icon-button>
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

  </div>
</div>
<mat-progress-bar color="accent" mode="determinate" [value]="interval$ | async"></mat-progress-bar>
